// extracted by mini-css-extract-plugin
export var navButton = "NavButton-module--nav-button--1WWBV";
export var clicked = "NavButton-module--clicked--finJB";